var map = {
	"./fondo.svg": "3f10",
	"./info-foprovep.jpg": "9017",
	"./itsmo_costa.svg": "a139",
	"./region_altos.svg": "aa80",
	"./region_centro.svg": "2e95",
	"./region_frailesca.svg": "f677",
	"./region_fronteriza.svg": "50ff",
	"./region_norte.svg": "73fe",
	"./region_selva.svg": "653a",
	"./region_sierra.svg": "8faa",
	"./region_soconusco.svg": "ef00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0238";